module.exports = __webpack_public_path__ + "media/theme/flag__sale-6b03b860.png";